export const BENTO_ORDERING_APP = 'BENTO_ORDERING_APP';
export const CATERING_APP = 'CATERING_APP';
